<template>
  <div class="aaa">
    <!-- 头部列表 Start-->
      <!-- 四周边框背景 Start-->
    <div class="home"></div>
      <!-- 四周边框背景 end-->
    <PopUP @hide='hide' :flage="flage"/>
      <!-- 头部列表 Start-->
    <div class="lists">
      <div
        class="lisy-now"
        v-for="(item, i) in list"
        :key="i"
        :style="{
          backgroundImage: keys == i ? `url(${images})` : `url(${item.image})`,
        }"
        :class="{ colrs: i == keys }"
        @click="app(i)"
      >
        {{ item.nama }}
      </div>
    </div>
      <!-- 头部列表 end-->
    <!-- 头部列表的二级列表 end-->
    <!-- 标题 Start-->
    <titlE />
    <!-- 标题 end-->
    <!--场景全览地下管网 Start-->
    <towbotM />
    <!--场景全览地下管网 end-->
    <!--底部列表 Start-->
    <subject />
    <!--底部列表 end-->
    <!-- <Waring @whide='whide' :waring="waring"/> -->
  </div>
</template>

<script>
import titlE from "../components/title.vue";
import towbotM from "../components/towbootm.vue";
import subject from "../components/subject.vue";
import PopUP from "../components/PopUp";
import Waring from "../components/Waring"
export default {
  name: "Home",
  data() {
    return {
      keys: -1,
      list: [
        { nama: "历史数据", image: require("../assets/listtitle.png") },
        { nama: "异常报警", image: require("../assets/listtitle.png") },
        { nama: "工艺展示", image: require("../assets/listtitle.png") }
      ],
      images: require("../assets/listtitle.png"),
      flage:false,
      waring:false
    };
  },
  mounted() {
    window.hide1 = this.hide1;
    this.emit.$on("back", () => {
      this.keys = 100;
    });
  },
  components: {
    titlE,
    towbotM,
    subject,
    PopUP,
    Waring
  },
  methods: {
    app(i) {
      if (this.keys == i) {
        this.keys = null;
        //不选中
        this.flage = false;
        this.waring = false;
         document.getElementById('iframe').contentWindow.MMAPI.Process()
        return;
      }
      //选中
      this.keys = i;
      if(this.keys==0){
        this.flage = true;
        this.waring = false;
      }else if(this.keys==1){
        this.flage = false;
        this.waring = true;
        document.getElementById('iframe').contentWindow.MMAPI.police()
        console.log(this.waring);
      }
      else if(this.keys==2){
        this.flage = false;
        this.waring = true;
       document.getElementById('iframe').contentWindow.MMAPI.Process()
        console.log(this.waring);
      }

    },
    hide(flage){
      this.flage =flage;
      this.keys = null;
    },
    whide(flage){
      this.waring =flage;
      this.keys = null;
    },
    hide1(){
      this.keys = null;
    }
  },
};
</script>
<style lang="less" scoped>
.home {
  width: 100%;
  height: 100vh;
  background-image: url("../assets/drouback.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  pointer-events: none;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}
.lists {
  width: 38.2vw;
  height: 5vh;
  position: absolute;
  z-index: 1;
  left: 40%;
  top: 2.2%;
  display: flex;
  align-items: center;

  .lisy-now {
    width: 8.5vw;
    height: 90%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
    font-size: 1vw;
    font-family: "YouSheBiaoTiHei";
    color: rgb(0, 255, 234);
    margin-right: 10px;
  }

  .colrs {
    color: rgb(255, 255, 255);
  }
}
</style>
